import {TstzSpan} from "../tstzspan.ts";
import {AgentStub} from "../rpc/webrpc-client.gen.ts";
import {Button, Stack} from "@mui/joy";
import {AgentCapsule} from "../agent/capsule.tsx";
import {DateArg, format} from "date-fns";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/pro-regular-svg-icons";
import {keyify} from "../util/arutil.tsx";

// import SlickSlider from "react-slick";

export interface RevisionStub  {
    author: AgentStub;
    validSpan: TstzSpan;
}

export interface RevisionBrowserProps {
    revisions: RevisionStub[];
    asof?: DateArg<Date>;

    onSelectionChange: (newSelection: RevisionStub) => void;
}

const dateFormatString = "yyyy.MM.dd HH:mm";

export function RevisionBrowser(props: RevisionBrowserProps) {
    const {revisions, asof, onSelectionChange} = props;
    const {t} = useTranslation();

    if (revisions.length < 2) {
        return null;
    }

    const selection = findValidRevision({revisions, asof});
    const keyedRevisions = keyify(revisions);

    // return <SlickSlider dots={true} infinite={true} speed={500}
    //                     slidesToShow={1} slidesToScroll={1}>
    return <Stack direction="row" spacing={1}>
        {keyedRevisions.map(({key, elem}) => {
                const color = "primary";
                const variant = elem === selection ? "solid" : "soft"
                return <Button key={key} color={color} variant={variant}
                               onClick={() => {
                                   if (elem !== selection) {
                                       onSelectionChange(elem);
                                   }
                               }}>
                    <Stack direction="column" sx={{alignItems: "center"}}>
                        <AgentCapsule agent={elem.author}/>
                        <Stack direction="row" sx={{alignItems: "center", columnGap: 0.6}}>
                            {format(elem.validSpan.lower!, dateFormatString)}
                            <FontAwesomeIcon icon={faArrowRight}/>
                        </Stack>
                        <Stack direction="row" sx={{alignItems: "center", columnGap: 0.6}}>
                            <FontAwesomeIcon icon={faArrowRight}/>
                            {elem.validSpan.upper
                                ? format(elem.validSpan.upper, dateFormatString)
                                : t("now")}
                        </Stack>
                    </Stack>
                </Button>
            }
        )}
    </Stack>
}

export interface FindValidRevisionArgs {
    revisions: RevisionStub[];
    asof?: DateArg<Date>;
}

export function findValidRevision({revisions, asof}: FindValidRevisionArgs) {
    if (!asof) {
        return revisions[revisions.length - 1];
    }
    const rv =
        revisions.findLast(maybe => maybe.validSpan.contains(asof));
    return rv;
}
